import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import GoogleMapComponent from './GoogleMap';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real implementation, you would send the form data to your backend
    console.log('Form submitted:', formData);
    // Simulate form submission success
    setFormStatus('success');
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
    // Reset form status after 5 seconds
    setTimeout(() => {
      setFormStatus(null);
    }, 5000);
  };

  return (
    <section id="contact" className="section bg-light-dark">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-primary mb-6">Contact Us</h2>
            <p className="text-lg mb-8">
              If you are looking for affordable SEO services that will help your business to grow, 
              drop us a message or give us a call and we'll be happy to help.
            </p>
            
            <div className="space-y-6 mb-8">
              <ContactInfo 
                icon={<FaMapMarkerAlt />}
                title="Address"
                content={
                  <>
                    11 Moore Street<br />
                    Rochester<br />
                    Kent ME2 3BD
                  </>
                }
              />
              
              <ContactInfo 
                icon={<FaPhone />}
                title="Phone"
                content="07949 248 272"
                href="tel:07949248272"
              />
              
              <ContactInfo 
                icon={<FaEnvelope />}
                title="Email"
                content="info@amplifiedseo.co.uk"
                href="mailto:info@amplifiedseo.co.uk"
              />
            </div>
            
            <div className="rounded-custom overflow-hidden h-64 bg-gray-200">
              {/* Google Maps Component */}
              <GoogleMapComponent />
            </div>
          </div>
          
          <div>
            <div className="bg-white rounded-custom shadow-custom p-8">
              <h3 className="text-primary mb-6">Get in Touch</h3>
              
              {formStatus === 'success' && (
                <div className="bg-green-100 border border-green-300 text-green-700 px-4 py-3 rounded-custom mb-6">
                  Thanks for your message! We'll get back to you shortly.
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label htmlFor="name" className="block text-dark mb-2">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-custom focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="email" className="block text-dark mb-2">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-3 border border-gray-300 rounded-custom focus:outline-none focus:ring-2 focus:ring-primary"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="phone" className="block text-dark mb-2">Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full p-3 border border-gray-300 rounded-custom focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                  </div>
                </div>
                
                <div className="mb-4">
                  <label htmlFor="service" className="block text-dark mb-2">Service Interested In</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-custom focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    <option value="">Please select...</option>
                    <option value="small-business">Small Business SEO</option>
                    <option value="ecommerce">E-commerce SEO</option>
                    <option value="white-label">White Label SEO</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div className="mb-6">
                  <label htmlFor="message" className="block text-dark mb-2">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className="w-full p-3 border border-gray-300 rounded-custom focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="btn btn-accent w-full"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ContactInfo = ({ icon, title, content, href }) => {
  const ContentWrapper = href ? 'a' : 'div';
  const wrapperProps = href ? { href, className: 'hover:text-accent' } : {};
  
  return (
    <div className="flex">
      <div className="text-accent text-xl mr-4 mt-1">
        {icon}
      </div>
      <div>
        <h4 className="font-bold mb-1">{title}</h4>
        <ContentWrapper {...wrapperProps}>
          {content}
        </ContentWrapper>
      </div>
    </div>
  );
};

export default Contact;